import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiFileText, FiClipboard, FiTrendingUp, FiUsers, FiChevronRight, FiActivity } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import StatCard from '../../components/ui/StatCard';
import SectionCard from '../../components/ui/SectionCard';
import ListItem from '../../components/ui/ListItem';
import EmptyState from '../../components/ui/EmptyState';
import StatusBadge from '../../components/ui/StatusBadge';
import { useAuth } from '../../context/AuthContext';
import { getAnalystStats } from '../../services/statsService';
import { timeAgo } from '../../utils/format';

export default function AnalystDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let active = true;
    getAnalystStats().then((data) => {
      if (active) setStats(data);
    });
    return () => {
      active = false;
    };
  }, []);

  return (
    <DashboardLayout title={`Hola, ${user.name.split(' ')[0]}`} subtitle="Analista · Vista general">
      <section className="kpi-grid">
        <StatCard icon={<FiFileText />} value={stats?.totalSubmissions ?? '—'} label="Registros totales" tone="muted" />
        <StatCard icon={<FiClipboard />} value={stats?.activeForms ?? '—'} label="Formularios activos" />
        <StatCard icon={<FiTrendingUp />} value={stats ? `${stats.completionRate}%` : '—'} label="Tasa de aprobación" tone="success" />
        <StatCard icon={<FiUsers />} value={stats?.activeAnalysts ?? '—'} label="Analistas activos" tone="warning" />
      </section>

      <SectionCard title="Explorar">
        <ListItem
          as={Link}
          to="/analyst/reports"
          icon={<FiTrendingUp />}
          title="Reportes por formulario"
          meta="Comparación de resultados"
          right={<FiChevronRight />}
        />
        <ListItem
          as={Link}
          to="/analyst/activity"
          icon={<FiActivity />}
          title="Actividad reciente"
          meta="Últimos registros del equipo"
          right={<FiChevronRight />}
        />
      </SectionCard>

      <SectionCard title="Últimos registros" action={<Link to="/analyst/activity">Ver todo</Link>}>
        {stats === null && <EmptyState icon={<FiFileText />} title="Cargando actividad…" />}
        {stats?.recent.length === 0 && <EmptyState icon={<FiFileText />} title="Sin actividad reciente" />}
        {stats?.recent.map((item) => (
          <ListItem
            key={item.id}
            icon={<FiFileText />}
            title={item.formTitle}
            meta={`${item.submittedByName} · ${timeAgo(item.submittedAt)}`}
            right={<StatusBadge status={item.status} />}
          />
        ))}
      </SectionCard>
    </DashboardLayout>
  );
}
